<div class="content">
  <!-- <div *ngIf="loading" class="loading">
    <mat-progress-spinner color="primary" mode="indeterminate" diameter="101">
    </mat-progress-spinner>
  </div> -->
  <div class="body" >
    <div class="header">
      <div class="welcome">Welcome, {{getUserName()}}!</div>
    </div>
    <div class="tabs">
      <button mat-button class="body-standard-tab" [ngClass]="{selected: tabIndex == 0}" (click)="setTab(0)">Schedule</button>
      <button mat-button class="body-standard-tab" [ngClass]="{selected: tabIndex == 1}" (click)="setTab(1)">Queue </button>

    </div>
      <div class="calendar-container" *ngIf="!isLoading() && tabIndex === 0">
        <calendar-view (editCalendarEvent)="editCalendarEvent($event)" [baseCalendarEvents]="currentTeamItems"></calendar-view>
      </div>
      <div class="queue-container" *ngIf="!isLoading() && tabIndex === 1">
        <div class="search-form" >
          <mat-form-field class="search-bar" appearance="outline">
            <button class="search-icon" (click)="doSearch($event)"  matPrefix mat-button><mat-icon>search</mat-icon></button>
            <input matInput (keyup)="checkSearchValue($event)"  (keydown.enter)="doSearch($event)" placeholder="Search for queue items" (input)="searchField = $event.target.value" [value]="searchField">
            <span matSuffix > </span>
          </mat-form-field>
        </div>  
        <div class="list-header">
          <mat-paginator *ngIf="queuePage" [pageSizeOptions]="[10, 25, 50]"
              showFirstLastButtons 
              aria-label="Select page of items"
              [pageSize]="size"
              (page)="pageQueue($event)"
              [length]="getQueueSize()"
              [pageIndex]="getPageNumber()"
              >
          </mat-paginator>
        </div>

        <table  *ngIf="queuePage" class="queue-table" mat-table [dataSource]="queuePage.content" matSort (matSortChange)="changeSort($event)">
          <ng-container matColumnDef="itemType">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> Type </th>
            <td  mat-cell (click)="onClickItem(item, 'itemType')" *matCellDef="let item"> {{getQueueItemValue(item, 'itemType')}} </td>
          </ng-container>
          <ng-container matColumnDef="is_late_flag">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> Is late? </th>
            <td  mat-cell (click)="onClickItem(item, 'is_late_flag')" *matCellDef="let item"> <span *ngIf="item.late" class="late-style"><mat-icon>notification_important</mat-icon></span> </td>
          </ng-container>
          <ng-container matColumnDef="startDateTime">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> Start </th>
            <td  mat-cell (click)="onClickItem(item, 'startDateTime')" *matCellDef="let item">{{getQueueItemValue(item, 'startDateTime') | date:'short'}} </td>
          </ng-container>
          <ng-container matColumnDef="expected">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> Date Due </th>
            <td  mat-cell (click)="onClickItem(item, 'expected')" *matCellDef="let item"> <span *ngIf="item.expected && item.expected > 0">{{getQueueItemValue(item, 'expected') | date:'short'}}</span><span *ngIf="!item.expected || item.expected <= 0">-</span></td>
          </ng-container>
          <ng-container matColumnDef="endDateTime">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> End </th>
            <td  mat-cell (click)="onClickItem(item, 'endDateTime')" *matCellDef="let item"> {{getQueueItemValue(item, 'endDateTime') | date:'short'}} </td>
          </ng-container>
          <ng-container matColumnDef="description">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> Description </th>
            <td  mat-cell (click)="onClickItem(item, 'description')" *matCellDef="let item"> {{getQueueItemValue(item, 'description')}} </td>
          </ng-container>
          <ng-container matColumnDef="status">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> Status </th>
            <td  mat-cell (click)="onClickItem(item, 'status')" *matCellDef="let item"> {{getQueueItemValue(item, 'status') | titlecase}} </td>
          </ng-container>
          <ng-container matColumnDef="teamMember">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> Team Member </th>
            <td  mat-cell (click)="onClickItem(item, 'teamMember')" *matCellDef="let item"> {{getQueueItemValue(item, 'teamMember')}} </td>
          </ng-container>
          <ng-container matColumnDef="familyIdentifier">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> Family Identifier </th>
            <td  mat-cell (click)="onClickItem(item, 'familyIdentifier')" *matCellDef="let item"> {{getQueueItemValue(item, 'familyIdentifier')}} </td>
          </ng-container>
          <ng-container matColumnDef="familyPrimary">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> Family Primary </th>
            <td  mat-cell (click)="onClickItem(item, 'familyPrimary')" *matCellDef="let item"> {{getQueueItemValue(item, 'familyPrimary')}} </td>
          </ng-container>
          <tr mat-header-row *matHeaderRowDef="displayColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayColumns;"></tr>
        </table>


      </div>
      <div class="add-new-container"  *ngIf="!isLoading()">
        <button mat-fab color="primary" (click)="editCalendarEvent(null)" >
      + {{getCalendarAction()}}  new
        </button>
      </div>
  </div>
</div>
